import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SmartDevicesService } from '../service/smart-devices.service';

@Injectable({
  providedIn: 'root',
})
export class HasSmartAccountsGuard  {
  constructor(
    private smartService: SmartDevicesService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.smartService.getConnectedAccounts().pipe(
      map((res) => {
        if (res.length > 0) {
          return true;
        } else {
          this.router.navigate(['/demo/devices']);
          return false;
        }
      })
    );
  }
}
